import { render, staticRenderFns } from "./qyzjgzltrList.vue?vue&type=template&id=1fefac81&scoped=true&"
import script from "./qyzjgzltrList.vue?vue&type=script&lang=js&"
export * from "./qyzjgzltrList.vue?vue&type=script&lang=js&"
import style0 from "./qyzjgzltrList.vue?vue&type=style&index=0&id=1fefac81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fefac81",
  null
  
)

export default component.exports